import footer_csd from "../../assets/companylogo.svg";

import { ImFacebook2, ImInstagram, ImTwitter } from "react-icons/im";
import { FaWhatsapp } from "react-icons/fa";

import { GlobalData } from "../../assets/data/GlodalData";

import FooterLogo1 from "./FooterLogo1.png";
import FooterLogo2 from "./FooterLogo2.png";
import FooterLogo3 from "./FooterLogo3.png";
import FooterLogo4 from "./FooterLogo4.png";
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <main className="bg-primary justify-center text-white">
      {/* Footer */}
      <section className="bg-primary pb-5">
        <footer>
          <div className="max-w-screen-xl px-4 py-16 mx-auto sm:px-9 lg:px-8">
            <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
              <div>
                <a href="/">
                  <img
                    src={footer_csd}
                    alt="footer_csd"
                    width="200"
                    height="200"
                  />
                </a>
                <p className="max-w-xs mt-4 text-[12px] text-white ">
                  We are a premier maritime logistics and supply chain management company with over 30 years of experience. Our mission is to streamline global trade through integrity, excellence, and unwavering dedication to client satisfaction.
                  <br />
                </p>


              </div>
              <div className="grid grid-cols-2 gap-8 lg:col-span-2 lg:grid-cols-4">
                <div>
                  <p className="font-medium text-white">Company</p>
                  <nav className="flex flex-col mt-4 space-y-2 text-[12px] text-white">
                    <a href="/aboutus"> About Us </a>
                    <a href="/services"> Services </a>
                    <a href="/operations"> Operations </a>
                  </nav>
                </div>

                <div>
                  <p className="font-medium text-white">Helpful Links</p>
                  <nav className="flex flex-col mt-4 space-y-2 text-[12px] text-white">
                    <a href="/contactus"> Contact </a>
                    <a href="/frequently-asked-questions"> FAQs </a>

                  </nav>
                </div>
                
              </div>
            </div>
            <div className="border-t border-gray-200 pt-6 mt-8">

              <div className="flex flex-col md:flex-row justify-between items-center gap-2">
                <div className="text-xs text-left">
                  <a
                    href="https://www.cyberspacedigital.in"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[12px] text-left cursor-pointer hover:underline hover:text-gray-300 transition-colors"
                  >
                    Maintained by Cyber Space Digital.<br />
                    A Development & Designer Community ( #CSD )
                  </a>
                </div>




                <div className="text-[12px] text-white text-center">
                  © 2018-{currentYear} shivamshippingandlogistics-scm.com
                  <div className="text-xs ">All Rights Reserved</div>
                </div>



                <div className="flex text-white text-[12px] space-x-2">
                  <a href="/Legal/privacy-policy">Privacy Policy</a> <div className="border-r-[0.5px]" />
                  <a href="/Legal/terms-and-conditions">Terms & Conditions</a> <div className="border-r-[0.5px]" />
                  <a href="/Legal/disclaimer">Disclaimer</a> <div className="border-r-[0.5px]" />
                  <a href="/sitemap.xml">Site Map</a>
                </div>
              </div>
            </div>

          </div>
        </footer>
        <section />
      </section>

      <div
        className="flex flex-col fixed left-2 z-50 items-center"
        style={{
          bottom: "calc(env(safe-area-inset-bottom, 0px) + 1rem)",
        }}
      >

      </div>
    </main>
  );
};

export default Footer;